export enum EnrollmentCheckoutType {
    agentCallCenterEmail = 'AE',
    agentCallCenterSMS = 'AS',
    agentCallCenterPhone = 'AP',
    agentCallCenterCode = 'AC',
    agentCallCenterOverride = 'AN',
}